export function Logo() {
    
    return (
      <h1 className='text-4xl text-blue font-extrabold'>
          Scratch
      </h1>
    );
  }